var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 92,
    viewBox: "0 0 78 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M45.1593 41.3205C45.3969 40.7251 45.8029 40.2119 46.3276 39.8435C46.8522 39.4752 47.4729 39.2678 48.1136 39.2466H72.7539C74.2296 39.2466 75.2274 40.4429 74.9898 41.9214L67.1947 88.4601C67.0573 89.1961 66.6731 89.8632 66.1055 90.3515C65.538 90.8398 64.821 91.12 64.0728 91.1461H2.28757C1.95115 91.1591 1.61623 91.0948 1.30854 90.9582C1.00084 90.8215 0.728576 90.6162 0.512648 90.3579C0.29672 90.0996 0.142882 89.7952 0.0629592 89.4681C-0.0169641 89.1411 -0.0208453 88.8001 0.0516107 88.4713L6.67844 48.8529C6.81863 48.1192 7.20393 47.4549 7.77116 46.969C8.33839 46.483 9.0539 46.2041 9.8004 46.1781H38.2586C41.1709 46.1669 44.0302 44.1574 45.1593 41.3205Z",
    fill: "#06A256"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.1593 41.3205C45.3969 40.7251 45.8029 40.2119 46.3276 39.8435C46.8522 39.4752 47.4729 39.2678 48.1136 39.2466H72.7539C74.2296 39.2466 75.2274 40.4429 74.9898 41.9214L67.1947 88.4601C67.0573 89.1961 66.6731 89.8632 66.1055 90.3515C65.538 90.8398 64.821 91.12 64.0728 91.1461H2.28757C1.95115 91.1591 1.61623 91.0948 1.30854 90.9582C1.00084 90.8215 0.728576 90.6162 0.512648 90.3579C0.29672 90.0996 0.142882 89.7952 0.0629592 89.4681C-0.0169641 89.1411 -0.0208453 88.8001 0.0516107 88.4713L6.67844 48.8529C6.81863 48.1192 7.20393 47.4549 7.77116 46.969C8.33839 46.483 9.0539 46.2041 9.8004 46.1781H38.2586C41.1709 46.1669 44.0302 44.1574 45.1593 41.3205Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M35.3518 0L16.7067 64.787L59.3577 77.0596L78 12.2726L35.3518 0Z",
    fill: "#06A256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.3518 0L16.7067 64.787L59.3577 77.0596L78 12.2726L35.3518 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5245 2.87042L16.7067 64.787L57.9071 76.6431L74.6069 12.5605L34.5245 2.87042Z",
    fill: "#06A256"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.5245 2.87042L16.7067 64.787L57.9071 76.6431L74.6069 12.5605L34.5245 2.87042Z",
    fill: "#06A256"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5245 2.87042L16.7067 64.787L57.9071 76.6431L74.6069 12.5605L34.5245 2.87042Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.5245 2.87042L16.7067 64.787L57.9071 76.6431L74.6069 12.5605L34.5245 2.87042Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6267 20.4112C52.4221 17.2146 52.0969 12.3571 48.9004 9.5617C45.7038 6.76627 40.8463 7.09146 38.0509 10.288C35.2555 13.4846 35.5806 18.3421 38.7772 21.1375C41.9738 23.9329 46.8313 23.6078 49.6267 20.4112Z",
    fill: "#06A256"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1519 21.1969C40.9944 20.8624 39.9621 20.1923 39.1854 19.2712C38.4087 18.3502 37.9225 17.2195 37.7882 16.0221C37.654 14.8248 37.8778 13.6145 38.4313 12.5443C38.9848 11.4741 39.8432 10.592 40.8979 10.0096C41.9526 9.42716 43.1563 9.17049 44.3569 9.27205C45.5575 9.37361 46.701 9.82884 47.6429 10.5802C48.5848 11.3315 49.2827 12.3452 49.6486 13.4932C50.0145 14.6412 50.0318 15.8718 49.6983 17.0296C49.4771 17.7991 49.1063 18.5175 48.6071 19.1435C48.1079 19.7696 47.4902 20.2911 46.7893 20.6781C46.0884 21.0652 45.318 21.3103 44.5223 21.3993C43.7265 21.4883 42.9211 21.4195 42.1519 21.1969Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8042 27.613L33.2291 23.7076L32.3513 26.7589L45.9264 30.6643L46.8042 27.613Z",
    fill: "#06A256"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3267 51.5364L25.8435 49.3835L22.4311 61.2449L29.9143 63.3978L33.3267 51.5364Z",
    fill: "#06A256"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8062 59.1557L52.323 57.0028L48.9106 68.8642L56.3938 71.0171L59.8062 59.1557Z",
    fill: "#06A256"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5651 55.3474L39.0818 53.1946L35.6694 65.056L43.1527 67.2088L46.5651 55.3474Z",
    fill: "#06A256"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7735 30.7664L48.59 28.1244L47.7122 31.1757L56.8957 33.8177L57.7735 30.7664Z",
    fill: "#06A256"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9263 40.0033L31.3217 30.3356L30.96 31.5926L64.5646 41.2603L64.9263 40.0033Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2631 37.8137L30.5535 33.0065L30.1918 34.2635L46.9015 39.0707L47.2631 37.8137Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.298 41.8515L50.1216 38.6362L49.7599 39.8932L60.9364 43.1086L61.298 41.8515Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6475 43.4035L29.7847 35.6754L29.4231 36.9324L56.2858 44.6605L56.6475 43.4035Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5549 47.5088L28.7094 38.5121L28.3431 39.7679L59.1886 48.7645L59.5549 47.5088Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8137 42.0452L28.2467 41.019L27.8851 42.276L31.4521 43.3022L31.8137 42.0452Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4379 47.4037L34.6764 42.8693L34.3148 44.1263L50.0762 48.6607L50.4379 47.4037Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0841 53.3591L27.4795 43.6913L27.1179 44.9484L60.7225 54.6161L61.0841 53.3591Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.388 2.26672L13.9956 67.6686L57.0379 78.4599L73.4274 13.058L30.388 2.26672Z",
    fill: "#06A256"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.388 2.26672L13.9956 67.6686L57.0379 78.4599L73.4274 13.058L30.388 2.26672Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.744 24.2142C46.5678 22.3673 48.1704 17.7703 46.3236 13.9465C44.4767 10.1227 39.8797 8.52004 36.0559 10.3669C32.2321 12.2138 30.6294 16.8108 32.4763 20.6346C34.3232 24.4584 38.9201 26.061 42.744 24.2142Z",
    fill: "#06A256"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3882 18.3932C45.9939 15.0831 43.8016 11.9087 40.4915 11.303C37.1814 10.6973 34.007 12.8896 33.4013 16.1997C32.7955 19.5098 34.9879 22.6842 38.298 23.2899C41.6081 23.8957 44.7825 21.7033 45.3882 18.3932Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7891 29.4599L29.0872 26.0259L28.3153 29.1057L42.0172 32.5397L42.7891 29.4599Z",
    fill: "#06A256"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1458 53.836L22.5927 51.943L19.5921 63.9152L27.1452 65.8082L30.1458 53.836Z",
    fill: "#06A256"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8694 60.5346L49.3163 58.6416L46.3157 70.6138L53.8689 72.5068L56.8694 60.5346Z",
    fill: "#06A256"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5087 57.1852L35.9556 55.2922L32.955 67.2645L40.5081 69.1575L43.5087 57.1852Z",
    fill: "#06A256"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8575 32.2328L44.5882 29.9097L43.8163 32.9895L53.0856 35.3127L53.8575 32.2328Z",
    fill: "#06A256"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3267 41.2159L27.4081 32.715L27.0901 33.9838L61.0087 42.4847L61.3267 41.2159Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5996 39.637L26.7339 35.41L26.4159 36.6788L43.2817 40.9058L43.5996 39.637Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7648 43.1864L46.4839 40.3591L46.1659 41.6279L57.4468 44.4552L57.7648 43.1864Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1707 44.9014L26.0569 38.106L25.739 39.3748L52.8527 46.1702L53.1707 44.9014Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5504 48.6155L25.3835 40.8043L25.0656 42.0731L56.2324 49.8843L56.5504 48.6155Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3062 44.4051L24.7059 43.5028L24.3879 44.7716L27.9882 45.6739L28.3062 44.4051Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1044 49.1131L31.1957 45.126L30.8777 46.3948L46.7864 50.3819L47.1044 49.1131Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M57.949 54.6969L24.0305 46.196L23.7125 47.4648L57.631 55.9657L57.949 54.6969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvIcon);
export default __webpack_public_path__ + "static/media/cv-icon.7c5817d633558e797e65ed49c5916216.svg";
export { ForwardRef as ReactComponent };